import { Typography } from '@execonline-inc/execonline-ui';
import { observer } from 'mobx-react';
import { MutableRefObject } from 'react';
import { T } from '../../../../../Translations';
import ChatMessageBody from '../ConversationHistory/ChatDisplayHistory/ChatMessageBody';

interface Props {
  stream: string;
  endRef: MutableRefObject<HTMLDivElement | null>;
}

function Display({ stream, endRef }: Props) {
  return (
    <div className="py-6 px-4 bg-white whitespace-pre-wrap" ref={endRef}>
      <div className="flex items-center justify-start mb-2 ">
        <img src="/exo-logo.png" className="size-6" alt="EXO Logo" />
        <Typography variant="bodyMedium" fontWeight="semibold" className="ml-2">
          <T kind="EXO, AI Advisor" />
        </Typography>
      </div>
      <ChatMessageBody content={stream} />
    </div>
  );
}

export default observer(Display);
